/* Model */
class I18NResourceModel extends App.Models.BaseModel {
    modelUrl = 'I18NResource';
}

App.Models.I18NResource = I18NResourceModel;

/* Collection */
class I18NResourceCollection extends App.Collections.BaseCollection {
    url = 'I18NResource';
    model = App.Models.I18NResource;
}

App.Collections.I18NResources = I18NResourceCollection;

/* Router */
class I18NResourceRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'I18NResource';
        const model = App.Models.I18NResource;
        const collectionClass = App.Collections.I18NResources;

        super(entityName, model, collectionClass);
    }
}

App.Routers.I18NResource = I18NResourceRouter;
